import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import PDFViewer from "./PDFViewer";
import RelevantImages from "./RelevantImages";
import RelevantPDFViewer from "./RelevantPDFPages";

function RelevantSection({ imageUrls, pdfUrl, pageNumber }) {
  return (
    <>
      <div
        className=" bg-white  rounded-left"
        style={{ height: "100%", overflow: "hidden" }}
      >
        <div
          className="RelevantSection container mt-2 "
          style={{ height: "100%", overflow: "hidden" }}
        >
          <Tabs
            defaultActiveKey="view_document"
            id="uncontrolled-tab-example"
            className=" "
          >
            <Tab
              eventKey="view_document"
              title="View Document"
              className="  p-2 border-right"
            >
              <div
                className=" "
                style={{ height: "78vh", overflow: "auto" }}
              >
                <PDFViewer signedUrl={pdfUrl} />
              </div>
            </Tab>

            <Tab
              eventKey="relevant_pages"
              title="Relevant Pages"
              className="  p-2 border-right"
            >
              <div
                className="border "
                style={{ height: "78vh", overflow: "auto" }}
              >
                <RelevantPDFViewer signedUrl={pdfUrl} pageNumber={pageNumber} />
              </div>
            </Tab>
            <Tab
              eventKey="relevant_images"
              title="Relevant Images"
              className="  p-2 border-right"
            >
              <div
                className="border "
                style={{ height: "78vh", overflow: "auto" }}
              >
                <RelevantImages imageUrls={imageUrls} />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}

export default RelevantSection;
